<template>
  <v-sheet>
    <v-container class="py-4 py-lg-8">
      <v-flex text-center pb-5 display-1>Selected Publications</v-flex>
      <v-row>
        <v-col v-for="(item, i) in features" :key="i" cols="12" md="6" xl="4">
          <v-card outlined>
            <v-img :src="require('@/assets/images/pca_motion_mag2.gif')" aspect-ratio="2.2"></v-img>
            <v-responsive class="mx-auto pa-2">
              <div class="">Principle-Component-Analysis Based Motion Magnification for B-mode Visualization of Magnetomotive Ultrasound</div>
              <div class="text--secondary pt-1"><span class="text-decoration-underline ">Wei-Hsiang Shen</span>, Meng-Lin Li</div>
              <div class="text--secondary">IEEE International Ultrasonics Symposium (IUS) 2019</div>
              <div class="">[<a target="_blank" href="https://ieeexplore.ieee.org/abstract/document/8926060">paper</a>]</div>
            </v-responsive>
          </v-card>
        </v-col>
        <v-col v-for="(item, i) in features" :key="i" cols="12" md="6" xl="4">
          <v-card outlined>
            <v-img :src="require('@/assets/images/realtime_MMUS.png')" aspect-ratio="2.2"></v-img>
            <v-responsive class="mx-auto pa-2">
              <div class="">Toward Real Time Backward-Mode Pulsed Magnetomotive Ultrasound</div>
              <div class="text--secondary pt-1"><span class="text-decoration-underline ">Wei-Hsiang Shen</span>, Meng-Lin Li</div>
              <div class="text--secondary">IEEE International Ultrasonics Symposium (IUS) 2019</div>
              <div class="">[<a target="_blank" href="https://ieeexplore.ieee.org/abstract/document/8926244">paper</a>]</div>
            </v-responsive>
          </v-card>
        </v-col>

        <!-- <v-col v-for="(item, i) in features" :key="i" cols="12" md="6" xl="4">
          <v-card outlined>
            <v-img :src="item.image" height="280"></v-img>
            <v-responsive class="mx-auto pa-2">
              <div class="">{{ item.title }}</div>
              <div class="">{{ item.author }}</div>
              <div class="">{{ item.conference }}</div>
              <div class="">{{ item.paper }}</div>
              <div class="my-4">
                <router-link :to="item.link.to" class="text-decoration-none font-weight-bold text-h6">{{ item.link.title }}</router-link>
              </div>
            </v-responsive>
          </v-card>
        </v-col> -->
      </v-row>
    </v-container>
  </v-sheet>
</template>

<script>
export default {
  data() {
    return {
      features: [{
        title: 'Principle-Component-Analysis Based Motion Magnification for B-mode Visualization of Magnetomotive Ultrasound',
        author: 'Wei-Hsiang Shen, Meng-Lin Li',
        conference: 'asdf',
        paper: 'asdf',
        image: '/images/features/6.jpg',
        text: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptatum commodi corrupti maiores ex sunt dolorum inventore facilis reprehenderit ullam minima quaerat sit!',
        link: {
          title: 'Learn More',
          to: '#'
        }
      }, ]
    }
  }
}
</script>
